/* WV8 motion layer for the v8 homepage. Runs after wv7-home.js and only reads its markup. */
(function () {
  'use strict';

  var root = document.querySelector('[data-wv-home-page]');
  var gsap = window.gsap;
  var ScrollTrigger = window.ScrollTrigger;
  if (!root || !gsap || !ScrollTrigger || root.dataset.wvMotion === 'true') return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  root.dataset.wvMotion = 'true';

  gsap.registerPlugin(ScrollTrigger);
  if (window.SplitText) gsap.registerPlugin(window.SplitText);
  document.documentElement.classList.add('wv-motion');

  var $ = function (sel, ctx) { return (ctx || root).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); };
  var DESKTOP = '(min-width: 1025px)';
  var MOBILE_TABLET = '(max-width: 1024px)';

  var lenis = setupSmoothScroll();

  function setupSmoothScroll() {
    if (!window.Lenis) return null;
    if (window.matchMedia(MOBILE_TABLET).matches) return null;
    if (window.matchMedia('(hover: none) and (pointer: coarse)').matches) return null;
    var instance = new window.Lenis({ lerp: 0.085, wheelMultiplier: 1, anchors: { offset: -90 } });
    instance.on('scroll', ScrollTrigger.update);
    gsap.ticker.add(function (time) { instance.raf(time * 1000); });
    gsap.ticker.lagSmoothing(0);

    // Modal dialogs scroll on their own; the page underneath must stay still.
    $$('dialog').forEach(function (dialog) {
      dialog.setAttribute('data-lenis-prevent', '');
      new MutationObserver(function () {
        if ($$('dialog[open]').length) instance.stop(); else instance.start();
      }).observe(dialog, { attributes: true, attributeFilter: ['open'] });
    });
    return instance;
  }

  function heroScene() {
    var hero = $('.hero');
    if (!hero) return;
    var img = $('.hero-img', hero);
    var shade = $('.hero-shade', hero);
    var title = $('.hero-content h1', hero);
    var lead = $('.hero-content > .eyebrow', hero);
    var bottom = $('.hero-bottom', hero);
    var top = $('.hero-top', hero);
    var extras = $$('.scroll-cue, .photo-note', hero);

    gsap.timeline({ defaults: { ease: 'expo.out' } })
      .from(img, { scale: 1.18, duration: 2.2 }, 0)
      .from([lead, title, bottom], { yPercent: 40, opacity: 0, duration: 1.4, stagger: 0.12 }, 0.2)
      .from(top, { opacity: 0, y: -16, duration: 1.2 }, 0.5);

    var mm = gsap.matchMedia();
    mm.add(DESKTOP, function () {
      gsap.timeline({
        scrollTrigger: { trigger: hero, start: 'top top', end: '+=120%', pin: true, scrub: 0.8, anticipatePin: 1, refreshPriority: 6 }
      })
        .fromTo([img, shade],
          { clipPath: 'inset(0% 0% 0% 0% round 0px)' },
          { clipPath: 'inset(8% 6% 8% 6% round 36px)', ease: 'power2.inOut', duration: 1 }, 0)
        .fromTo(img, { scale: 1.12 }, { scale: 1, ease: 'power2.inOut', duration: 1 }, 0)
        .to(title, { scale: 0.78, yPercent: -18, ease: 'power2.inOut', duration: 1 }, 0)
        .to([bottom, top].concat(extras), { opacity: 0, y: -40, ease: 'power2.out', duration: 0.4, stagger: 0.03 }, 0)
        .to(lead, { opacity: 0.6, ease: 'none', duration: 0.4 }, 0);
    });

    var strip = $('.sector-strip');
    if (strip) {
      gsap.from(strip.children, {
        y: 46, opacity: 0, duration: 1.1, ease: 'expo.out', stagger: 0.06,
        scrollTrigger: { trigger: strip, start: 'top 92%' }
      });
    }
  }

  var splits = [];

  function headlineReveals() {
    var SplitText = window.SplitText;
    var headings = $$('h2').filter(function (h) { return !h.closest('dialog, .wv-spotlight'); });

    headings.forEach(function (h) {
      if (!SplitText) {
        gsap.from(h, { y: 60, opacity: 0, duration: 1.2, ease: 'expo.out', scrollTrigger: { trigger: h, start: 'top 88%' } });
        return;
      }
      splits.push(SplitText.create(h, {
        type: 'lines', mask: 'lines', linesClass: 'wv-line', autoSplit: true,
        onSplit: function (self) {
          return gsap.from(self.lines, {
            yPercent: 115, rotate: 2.5, duration: 1.25, ease: 'expo.out', stagger: 0.11,
            scrollTrigger: { trigger: h, start: 'top 88%' }
          });
        }
      }));
    });

    var kickers = $$('.section-heading .eyebrow, .section-label, .space-content > .eyebrow, .project-intro > .eyebrow, .faq-intro .eyebrow, .section-heading > p, .space-intro, .project-intro > p');
    kickers.forEach(function (el) {
      gsap.from(el, {
        y: 28, opacity: 0, duration: 1.1, ease: 'expo.out',
        scrollTrigger: { trigger: el, start: 'top 90%' }
      });
    });

    var intro = $$('.intro-copy p');
    if (SplitText && intro.length) {
      intro.forEach(function (p) {
        splits.push(SplitText.create(p, {
          type: 'words', wordsClass: 'wv-word', autoSplit: true,
          onSplit: function (self) {
            return gsap.fromTo(self.words, { opacity: 0.14 }, {
              opacity: 1, ease: 'none', stagger: 0.05,
              scrollTrigger: { trigger: p, start: 'top 82%', end: 'bottom 48%', scrub: true }
            });
          }
        }));
      });
    }
    var counts = $$('.category-counts a');
    if (counts.length) {
      gsap.from(counts, {
        y: 40, opacity: 0, duration: 1, ease: 'expo.out', stagger: 0.1,
        scrollTrigger: { trigger: counts[0], start: 'top 90%' }
      });
    }
  }

  var LIQUID_FROM = { y: -120, opacity: 0, scaleX: 0.88, scaleY: 1.04, rotationX: -10, filter: 'blur(14px)', transformPerspective: 900, transformOrigin: '50% 0%' };

  function liquidLand(targets, stagger) {
    var tl = gsap.timeline();
    tl.to(targets, { y: 0, scaleX: 1, scaleY: 1, rotationX: 0, duration: 1.35, ease: 'back.out(1.5)', stagger: stagger }, 0)
      .to(targets, { opacity: 1, filter: 'blur(0px)', duration: 0.9, ease: 'power2.out', stagger: stagger }, 0)
      .set(targets, { clearProps: 'transform,filter,opacity' });
    return tl;
  }

  function isMobileCatalog() {
    return window.matchMedia(MOBILE_TABLET).matches;
  }

  function revealCatalogCards(cards) {
    if (!cards || !cards.length) return;
    gsap.set(cards, { clearProps: 'opacity,transform,filter,y,scaleX,scaleY,rotationX' });
  }

  function ensureCatalogVisible(grid) {
    if (!isMobileCatalog() || !grid) return;
    var cards = $$('.product-card', grid);
    var hidden = cards.filter(function (c) {
      var o = parseFloat(getComputedStyle(c).opacity);
      return isNaN(o) || o < 0.1;
    });
    if (hidden.length) revealCatalogCards(hidden);
    $$('.catalog-group-heading', grid).forEach(function (head) {
      [].forEach.call(head.children, function (ch) {
        var o = parseFloat(getComputedStyle(ch).opacity);
        if (isNaN(o) || o < 0.1) gsap.set(ch, { clearProps: 'opacity,transform,filter' });
      });
    });
  }

  function scheduleEnsureCatalogVisible(grid) {
    if (!isMobileCatalog() || !grid) return;
    requestAnimationFrame(function () {
      ensureCatalogVisible(grid);
      setTimeout(function () { ensureCatalogVisible(grid); }, 0);
    });
  }

  var cardTriggers = [];
  var RAIL_CATEGORY = 'banos';

  // The ice baths become a pinned row that slides sideways as you scroll down.
  function railScene(section, cards) {
    var track = $('.category-product-grid', section);
    section.classList.add('wv-rail');
    var bar = document.createElement('div');
    bar.className = 'wv-rail-progress';
    bar.innerHTML = '<i></i>';
    section.appendChild(bar);

    var distance = function () { return Math.max(0, track.scrollWidth - track.clientWidth); };
    var start = function () { return section.offsetHeight < window.innerHeight ? 'center center' : 'top top'; };
    var slide = gsap.to(track, {
      x: function () { return -distance(); },
      ease: 'none',
      scrollTrigger: {
        trigger: section, start: start, end: function () { return '+=' + distance(); },
        pin: true, scrub: 0.7, anticipatePin: 1, invalidateOnRefresh: true, refreshPriority: 3
      }
    });
    var triggers = [slide.scrollTrigger];
    triggers.push(ScrollTrigger.create({
      trigger: section, start: start, end: function () { return '+=' + distance(); },
      animation: gsap.fromTo($('i', bar), { scaleX: 0 }, { scaleX: 1, ease: 'none' }), scrub: true
    }));

    var visible = cards.filter(function (c) { return c.offsetLeft < window.innerWidth * 0.85; });
    var later = cards.filter(function (c) { return visible.indexOf(c) < 0; });
    gsap.set(cards, LIQUID_FROM);
    triggers.push(ScrollTrigger.create({
      trigger: section, start: 'top 80%', once: true,
      onEnter: function () { liquidLand(visible, 0.1); }
    }));
    later.forEach(function (card) {
      triggers.push(ScrollTrigger.create({
        trigger: card, containerAnimation: slide, start: 'left 96%', once: true,
        onEnter: function () { liquidLand(card, 0); }
      }));
    });
    return triggers;
  }

  function liquidCatalog() {
    var grid = $('#product-grid');
    if (!grid) return;
    var desktop = window.matchMedia(DESKTOP);

    function arm() {
      cardTriggers.forEach(function (t) { t.kill(); });
      cardTriggers = [];
      var sections = $$('.catalog-category-section', grid);
      sections.forEach(function (s) { s.dataset.wvArmed = 'true'; });
      var cards = $$('.product-card', grid);
      if (!cards.length) { ScrollTrigger.refresh(); return; }

      var railSection = $('#categoria-' + RAIL_CATEGORY, grid);
      var railCards = railSection ? $$('.product-card', railSection) : [];
      var useRail = desktop.matches && railCards.length > 3;
      var fallCards = useRail ? cards.filter(function (c) { return railCards.indexOf(c) < 0; }) : cards;

      if (isMobileCatalog()) {
        revealCatalogCards(fallCards);
        cardTriggers = ScrollTrigger.batch(fallCards, {
          start: 'top 94%',
          once: true,
          batchMax: 4,
          interval: 0.08,
          onEnter: function (batch) {
            gsap.from(batch, {
              y: 24, opacity: 0, duration: 0.85, ease: 'expo.out', stagger: 0.06,
              clearProps: 'opacity,transform'
            });
          }
        });
      } else {
        gsap.set(fallCards, LIQUID_FROM);
        cardTriggers = ScrollTrigger.batch(fallCards, {
          start: 'top 94%',
          once: true,
          batchMax: 4,
          interval: 0.08,
          onEnter: function (batch) { liquidLand(batch, 0.09); }
        });
      }
      if (useRail) cardTriggers = cardTriggers.concat(railScene(railSection, railCards));
      $$('.catalog-group-heading', grid).forEach(function (head) {
        if (isMobileCatalog()) {
          cardTriggers.push(ScrollTrigger.create({
            trigger: head, start: 'top 90%', once: true,
            onEnter: function () {
              gsap.from(head.children, {
                y: 24, opacity: 0, duration: 0.9, ease: 'expo.out', stagger: 0.08,
                clearProps: 'opacity,transform'
              });
            }
          }));
        } else {
          cardTriggers.push(ScrollTrigger.create({
            trigger: head, start: 'top 90%', once: true,
            animation: gsap.from(head.children, { y: 50, opacity: 0, duration: 1.2, ease: 'expo.out', stagger: 0.1 })
          }));
        }
      });
      ScrollTrigger.sort();
      ScrollTrigger.refresh();
      scheduleEnsureCatalogVisible(grid);
    }

    arm();
    window.addEventListener('wv-catalog-rendered', function () {
      ScrollTrigger.refresh();
      scheduleEnsureCatalogVisible(grid);
    });
    // Pinning wraps sections in a spacer, which is also a childList change; only re-arm on a real re-render.
    new MutationObserver(function () {
      var sections = $$('.catalog-category-section', grid);
      var stale = sections.length
        ? sections.some(function (s) { return s.dataset.wvArmed !== 'true'; })
        : cardTriggers.length > 0;
      if (stale) arm();
    }).observe(grid, { childList: true });
    desktop.addEventListener('change', arm);

    var controls = $$('.catalog-controls, .catalog-count');
    gsap.from(controls, {
      y: 30, opacity: 0, duration: 1.1, ease: 'expo.out', stagger: 0.08,
      scrollTrigger: { trigger: controls[0], start: 'top 90%' }
    });
  }

  function projectScene() {
    var section = $('.wv-project');
    if (!section || section.hidden) return;
    var card = $('.wv-project-card', section);
    var visual = $('.wv-project-visual', section);
    var img = $('img', visual);
    var copy = $$('.wv-project-copy > .eyebrow, .wv-project-text', section);
    var tiles = $$('.wv-project-tiles li', section);
    var cta = $$('.wv-project-cta, .wv-project-note', section);

    gsap.set(tiles.concat(cta), LIQUID_FROM);
    gsap.from(card, {
      y: 90, opacity: 0, duration: 1.3, ease: 'expo.out',
      scrollTrigger: { trigger: section, start: 'top 85%' }
    });
    gsap.from(copy, {
      y: 30, opacity: 0, duration: 1, ease: 'expo.out', stagger: 0.08,
      scrollTrigger: { trigger: card, start: 'top 70%' }
    });
    ScrollTrigger.create({
      trigger: card, start: 'top 62%', once: true,
      onEnter: function () {
        liquidLand(tiles, 0.09);
        liquidLand(cta, 0.12).delay(0.45);
      }
    });
    gsap.timeline({ scrollTrigger: { trigger: section, start: 'top bottom', end: 'center center', scrub: 0.8 } })
      .fromTo(visual, { clipPath: 'inset(10% 12% 10% 0% round 32px)' }, { clipPath: 'inset(0% 0% 0% 0% round 0px)', ease: 'power2.out' }, 0)
      .fromTo(img, { scale: 1.22 }, { scale: 1, ease: 'power2.out' }, 0);
  }

  // Pins a section and lets scroll progress step through its tab buttons, as on Apple product pages.
  // The v8 click handlers still do the content swap; this only decides when to click and how to cross-fade.
  function pinnedTabs(opts) {
    var section = opts.section;
    var tabs = opts.tabs;
    var swapOut = opts.swapOut;
    var swapIn = opts.swapIn;
    var current = tabs.findIndex(function (t) { return t.getAttribute('aria-selected') === 'true'; });
    var swap = null;
    var jumping = false;
    var driving = false;

    function select(index) {
      driving = true;
      tabs[index].click();
      driving = false;
    }

    function show(index) {
      if (jumping || index === current) return;
      current = index;
      if (swap) swap.kill();
      swap = gsap.timeline()
        .to(swapOut, { opacity: 0, y: -18, duration: 0.24, ease: 'power2.in', stagger: 0.02 }, 0)
        .add(function () { select(index); })
        .fromTo(swapIn, { opacity: 0, y: 34 }, { opacity: 1, y: 0, duration: 0.8, ease: 'expo.out', stagger: 0.05 });
      if (opts.media) {
        swap.to(opts.media, { opacity: 0, scale: 1.06, duration: 0.28, ease: 'power2.in' }, 0)
          .fromTo(opts.media, { opacity: 0, scale: 1.1 }, { opacity: 1, scale: 1, duration: 0.9, ease: 'expo.out' }, 0.3);
      }
    }

    var st = ScrollTrigger.create({
      trigger: section,
      start: function () { return section.offsetHeight > window.innerHeight ? 'bottom bottom' : 'top top'; },
      end: '+=' + tabs.length * (opts.perTab || 70) + '%',
      pin: true,
      anticipatePin: 1,
      invalidateOnRefresh: true,
      refreshPriority: opts.priority || 0,
      animation: opts.scrub || null,
      scrub: opts.scrub ? 0.8 : false,
      onUpdate: function (self) {
        show(Math.min(tabs.length - 1, Math.floor(self.progress * tabs.length)));
      }
    });

    function onTabClick(e) {
      if (driving) return;
      var index = tabs.indexOf(e.currentTarget);
      current = index;
      if (window.scrollY > st.end) return;
      var y = st.start + (st.end - st.start) * (index + 0.5) / tabs.length;
      if (!lenis) { window.scrollTo(0, y); return; }
      jumping = true;
      lenis.scrollTo(y, { duration: 1.1, onComplete: function () { jumping = false; } });
    }
    tabs.forEach(function (t) { t.addEventListener('click', onTabClick); });

    return function () {
      tabs.forEach(function (t) { t.removeEventListener('click', onTabClick); });
      if (swap) swap.kill();
      gsap.set([].concat(opts.media || [], swapIn), { clearProps: 'opacity,transform' });
    };
  }

  function solutionsScene() {
    var section = $('.solutions');
    var tabs = $$('[data-solution]');
    if (!section || tabs.length < 2) return;
    var copy = $$('.solution-description > *');

    gsap.from('.solution-panel', {
      y: 80, opacity: 0, duration: 1.3, ease: 'expo.out',
      scrollTrigger: { trigger: '.solution-panel', start: 'top 88%' }
    });

    gsap.matchMedia().add(DESKTOP, function () {
      return pinnedTabs({ section: section, tabs: tabs, media: $('#solution-image'), swapOut: copy, swapIn: copy, priority: 5 });
    });
  }

  function spacesScene() {
    var section = $('.spaces');
    var tabs = $$('[data-sector]');
    if (!section || tabs.length < 2) return;
    var img = $('.wv-space-stack', section) || $('.space-visual img', section);
    var over = $('.space-over', section);
    var detail = $$('#sector-detail > *');

    gsap.from(tabs, {
      x: 60, opacity: 0, duration: 1.1, ease: 'expo.out', stagger: 0.09,
      scrollTrigger: { trigger: tabs[0], start: 'top 90%' }
    });

    var mm = gsap.matchMedia();
    mm.add(DESKTOP, function () {
      var zoom = gsap.timeline()
        .fromTo(img, { scale: 1.1 }, { scale: 1, ease: 'none' }, 0)
        .fromTo($('.space-visual', section),
          { clipPath: 'inset(6% 8% 6% 8% round 32px)' },
          { clipPath: 'inset(0% 0% 0% 0% round 0px)', ease: 'power2.out' }, 0)
        .fromTo(over, { y: 80, opacity: 0 }, { y: 0, opacity: 1, ease: 'power2.out', duration: 0.4 }, 0.1);
      return pinnedTabs({ section: section, tabs: tabs, swapOut: detail, swapIn: detail, perTab: 55, scrub: zoom, priority: 2 });
    });
    mm.add(MOBILE_TABLET, function () {
      gsap.fromTo(img, { scale: 1.06 }, {
        scale: 1, ease: 'none',
        scrollTrigger: { trigger: section, start: 'top bottom', end: 'bottom top', scrub: true }
      });
    });
  }

  function processScene() {
    var steps = $$('.process-grid article');
    if (!steps.length) return;
    var mid = (steps.length - 1) / 2;
    gsap.fromTo(steps, {
      y: 160, opacity: 0, rotation: function (i) { return (i - mid) * 5; },
      transformOrigin: '50% 120%', filter: 'blur(8px)'
    }, {
      y: 0, opacity: 1, rotation: 0, filter: 'blur(0px)', ease: 'power3.out', stagger: 0.08,
      scrollTrigger: { trigger: '.process-grid', start: 'top 92%', end: 'top 40%', scrub: 0.9 }
    });
  }

  function closingScenes() {
    var form = $('#brief-form');
    if (form) {
      gsap.set(form, LIQUID_FROM);
      ScrollTrigger.create({ trigger: form, start: 'top 88%', once: true, onEnter: function () { liquidLand(form, 0); } });
    }
    var faqs = $$('.faq details');
    if (faqs.length) {
      gsap.from(faqs, {
        y: 50, opacity: 0, duration: 1.1, ease: 'expo.out', stagger: 0.1,
        scrollTrigger: { trigger: faqs[0], start: 'top 90%' }
      });
    }
    var footer = root.querySelector('footer');
    if (footer) {
      gsap.from(footer.children, {
        y: 60, opacity: 0, duration: 1.2, ease: 'expo.out', stagger: 0.1,
        scrollTrigger: { trigger: footer, start: 'top 92%' }
      });
    }
  }

  var assetMap = {};
  try { assetMap = JSON.parse($('[data-wv-assets]').textContent); } catch (e) { assetMap = {}; }
  var asset = function (path) { return assetMap[path] || path; };

  function buildSpotlight() {
    var catalog = $('#catalogo');
    if (!catalog) return null;
    var section = document.createElement('section');
    section.className = 'wv-spotlight';
    section.id = 'wv-spotlight';
    section.setAttribute('aria-labelledby', 'wv-spot-title');
    var isEn = window.WV_LANG === 'en';
    section.innerHTML =
      '<div class="wv-spot-intro"><span class="eyebrow" data-wv-i18n-en="IN FOCUS · ICE BATHS">EN EL FOCO · BAÑOS DE INMERSIÓN</span>' +
      '<h2 id="wv-spot-title" data-wv-i18n-en-html="WV-G22 Professional.&lt;br&gt;&lt;em&gt;Professional line.&lt;/em&gt;">WV-G22 Professional.<br><em>Línea profesional.</em></h2></div>' +
      '<div class="wv-spot-stage"><div class="wv-spot-glow" aria-hidden="true"></div><div class="wv-spot-plinth">' +
      '<img src="' + asset('assets/catalog/cold-p15-native.png') + '" alt="WV-G22 Professional, bañera de inmersión de la línea profesional" data-wv-i18n-en-alt="WV-G22 Professional, professional-line ice bath" width="1448" height="1086" decoding="async"></div></div>' +
      '<ul class="wv-spot-callouts">' +
      '<li data-pos="tl"><b data-wv-i18n-en="WPC and stainless steel">WPC y acero inoxidable</b><span data-wv-i18n-en="Professional-line construction">Construcción de la línea profesional</span></li>' +
      '<li data-pos="tr"><b data-wv-i18n-en="2,000 × 843 × 750 mm">2.000 × 843 × 750 mm</b><span data-wv-i18n-en="Catalogue dimensions">Dimensiones de catálogo</span></li>' +
      '<li data-pos="bl"><b data-wv-i18n-en="WiFi and iOS / Android app">WiFi y app iOS / Android</b><span data-wv-i18n-en="Control from your phone">Control desde el móvil</span></li>' +
      '<li data-pos="br"><b data-wv-i18n-en="Indoor and outdoor">Interior y exterior</b><span data-wv-i18n-en="For professional projects">Para proyectos profesionales</span></li>' +
      '</ul>' +
      '<div class="wv-spot-actions"><button type="button" class="button dark" data-open-product="wv-g22-professional" data-wv-i18n-en-html="View details &lt;span&gt;↗&lt;/span&gt;">Ver ficha <span>↗</span></button>' +
      '<button type="button" class="button outline" data-project="wv-g22-professional" data-wv-i18n-skip>' + (isEn ? 'Add to project +' : 'Añadir al proyecto +') + '</button></div>';
    if (isEn && window.WV_I18N) window.WV_I18N.applyNative(section, 'en');
    catalog.before(section);
    return section;
  }

  function spotlightScene(section) {
    if (!section) return;
    var stage = $('.wv-spot-stage', section);
    var glow = $('.wv-spot-glow', section);
    var intro = $('.wv-spot-intro', section);
    var callouts = $$('.wv-spot-callouts li', section);
    var actions = $('.wv-spot-actions', section);

    var mm = gsap.matchMedia();
    mm.add(DESKTOP, function () {
      var tl = gsap.timeline({
        defaults: { ease: 'power2.out' },
        scrollTrigger: { trigger: section, start: 'top top', end: '+=260%', pin: true, scrub: 0.9, anticipatePin: 1, refreshPriority: 4 }
      });
      tl.fromTo(intro, { y: 60, opacity: 0 }, { y: 0, opacity: 1, duration: 0.15 }, 0)
        .fromTo(stage, { scale: 0.52, yPercent: 22, rotation: -9, opacity: 0 }, { scale: 1, yPercent: 0, rotation: 0, opacity: 1, duration: 0.35, ease: 'power3.out' }, 0.05)
        .fromTo(glow, { opacity: 0, scale: 0.6 }, { opacity: 1, scale: 1, duration: 0.35 }, 0.05)
        .to(intro, { opacity: 0.35, y: -20, duration: 0.15 }, 0.42);
      callouts.forEach(function (li, i) {
        var fromLeft = /l$/.test(li.dataset.pos);
        tl.fromTo(li, { opacity: 0, x: fromLeft ? -50 : 50 }, { opacity: 1, x: 0, duration: 0.12 }, 0.45 + i * 0.09)
          .fromTo($('b', li), { '--wv-line': 0 }, { '--wv-line': 1, duration: 0.12 }, 0.47 + i * 0.09);
      });
      tl.to(stage, { scale: 1.07, rotation: 2.5, duration: 0.2, ease: 'none' }, 0.8)
        .fromTo(actions, { y: 40, opacity: 0 }, { y: 0, opacity: 1, duration: 0.1 }, 0.82);
    });
    mm.add(MOBILE_TABLET, function () {
      gsap.from([intro, stage].concat(callouts, actions), {
        y: 50, opacity: 0, duration: 1.1, ease: 'expo.out', stagger: 0.08,
        scrollTrigger: { trigger: section, start: 'top 80%' }
      });
    });
  }

  // Each sector gets its own photo; the new one slides up over the last, which shrinks and dims.
  function spaceStack() {
    var visual = $('.space-visual');
    var base = visual && $('img', visual);
    var tabs = $$('[data-sector]');
    if (!base || tabs.length < 2) return;
    var stack = document.createElement('div');
    stack.className = 'wv-space-stack';
    base.before(stack);
    stack.appendChild(base);
    var extra = [
      ['assets/catalog/fitness-native-rgb-v4.webp', 'Zona de entrenamiento integrada con el bienestar, imagen del catálogo general', 'Training area integrated with the wellness space, general catalogue image'],
      ['assets/catalog/vapor-native-rgb-v4.webp', 'Baño de vapor a medida, imagen del catálogo general', 'Custom steam room, general catalogue image']
    ];
    var layers = [base];
    extra.slice(0, tabs.length - 1).forEach(function (pair) {
      var img = document.createElement('img');
      img.src = asset(pair[0]);
      img.alt = window.WV_LANG === 'en' ? pair[2] : pair[1];
      img.setAttribute('data-wv-i18n-es-alt', pair[1]);
      img.setAttribute('data-wv-i18n-en-alt', pair[2]);
      img.loading = 'lazy';
      img.decoding = 'async';
      stack.appendChild(img);
      layers.push(img);
    });

    var current = 0;
    var note = $('.photo-note', visual);
    function place(index, animate) {
      if (note) gsap.to(note, { opacity: index === 0 ? 1 : 0, duration: animate ? 0.4 : 0 });
      layers.forEach(function (layer, j) {
        var depth = index - j;
        var state = j > index
          ? { yPercent: 100, scale: 1, opacity: 1, filter: 'brightness(1)' }
          : { yPercent: 0, scale: depth ? 1 - 0.08 * depth : 1, opacity: depth > 1 ? 0 : 1, filter: depth ? 'brightness(.45)' : 'brightness(1)' };
        if (animate) gsap.to(layer, Object.assign({ duration: 1.1, ease: 'expo.out', overwrite: 'auto' }, state));
        else gsap.set(layer, state);
      });
    }
    place(0, false);

    var observer = new MutationObserver(function () {
      var index = tabs.findIndex(function (t) { return t.getAttribute('aria-selected') === 'true'; });
      if (index < 0 || index === current || index >= layers.length) return;
      current = index;
      place(index, true);
    });
    tabs.forEach(function (t) { observer.observe(t, { attributes: true, attributeFilter: ['aria-selected'] }); });
  }

  // The page colour eases between sections: warm for heat, cool for cold, deep red for light.
  function colourShift() {
    var TONES = {
      base: ['#11140f', 'rgba(211,140,99,.32)'],
      deep: ['#0b0d09', 'rgba(211,140,99,.28)'],
      heat: ['#1d130c', 'rgba(232,146,90,.42)'],
      cold: ['#0b151a', 'rgba(118,184,214,.36)'],
      light: ['#1c0b0b', 'rgba(232,78,62,.4)']
    };
    var solutionTone = function () {
      var on = $('[data-solution][aria-selected="true"]');
      return ({ sauna: 'heat', ice: 'cold', light: 'light' })[on ? on.dataset.solution : ''] || 'base';
    };
    var zones = [
      ['.hero', 'base'], ['.intro', 'base'], ['.solutions', solutionTone], ['#wv-spotlight', 'cold'],
      ['.catalog-section', 'base'], ['#categoria-saunas', 'heat'], ['#categoria-banos', 'cold'],
      ['#categoria-luz', 'light'], ['#categoria-accesorios', 'base'], ['.wv-project', 'heat'],
      ['.spaces', 'base'], ['.process', 'deep'], ['.project', 'heat'], ['.faq', 'base'], ['footer', 'deep']
    ];
    var active = null;
    var queued = false;

    function update() {
      queued = false;
      var mid = window.innerHeight * 0.5;
      var tone = 'base';
      zones.forEach(function (z) {
        var el = $(z[0]);
        if (!el) return;
        var r = el.getBoundingClientRect();
        if (r.top <= mid && r.bottom >= mid) tone = typeof z[1] === 'function' ? z[1]() : z[1];
      });
      if (tone === active) return;
      active = tone;
      gsap.to(root, { '--wv-bg': TONES[tone][0], '--wv-glow': TONES[tone][1], duration: 1.2, ease: 'power2.out', overwrite: 'auto' });
    }
    function queue() { if (!queued) { queued = true; requestAnimationFrame(update); } }

    if (lenis) lenis.on('scroll', queue); else window.addEventListener('scroll', queue, { passive: true });
    $$('[data-solution]').forEach(function (t) {
      new MutationObserver(queue).observe(t, { attributes: true, attributeFilter: ['aria-selected'] });
    });
    update();
  }

  // Cards lean toward the cursor with a copper sheen; primary buttons pull gently toward it.
  function pointerFx() {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    var tilted = null;
    function release(card) {
      gsap.to(card, { rotationX: 0, rotationY: 0, duration: 0.8, ease: 'power3.out', overwrite: 'auto' });
    }
    root.addEventListener('pointermove', function (e) {
      var card = e.target.closest ? e.target.closest('.product-card, .category-counts a, .wv-project-tiles li') : null;
      if (card && card.closest('.catalog-category-section')) return;
      if (tilted && tilted !== card) { release(tilted); tilted = null; }
      if (!card || gsap.isTweening(card) || card.closest('dialog')) return;
      tilted = card;
      var r = card.getBoundingClientRect();
      var px = (e.clientX - r.left) / r.width;
      var py = (e.clientY - r.top) / r.height;
      card.style.setProperty('--mx', (px * 100).toFixed(1) + '%');
      card.style.setProperty('--my', (py * 100).toFixed(1) + '%');
      gsap.to(card, {
        rotationY: (px - 0.5) * 9, rotationX: (0.5 - py) * 7, transformPerspective: 1000,
        duration: 0.6, ease: 'power3.out', overwrite: 'auto'
      });
    });
    root.addEventListener('pointerleave', function () { if (tilted) { release(tilted); tilted = null; } });

    root.addEventListener('pointermove', function (e) {
      var btn = e.target.closest ? e.target.closest('.button, .nav-cta') : null;
      if (!btn || btn.closest('dialog') || btn.disabled) return;
      var r = btn.getBoundingClientRect();
      var dx = gsap.utils.clamp(-14, 14, (e.clientX - (r.left + r.width / 2)) * 0.22);
      var dy = gsap.utils.clamp(-10, 10, (e.clientY - (r.top + r.height / 2)) * 0.35);
      gsap.to(btn, { x: dx, y: dy, duration: 0.4, ease: 'power3.out', overwrite: 'auto' });
      var arrow = $('span', btn);
      if (arrow) gsap.to(arrow, { x: dx * 0.5, y: dy * 0.5, duration: 0.4, ease: 'power3.out', overwrite: 'auto' });
    });
    root.addEventListener('pointerout', function (e) {
      var btn = e.target.closest ? e.target.closest('.button, .nav-cta') : null;
      if (!btn || btn.contains(e.relatedTarget)) return;
      gsap.to(btn, { x: 0, y: 0, duration: 0.9, ease: 'elastic.out(1, 0.4)', overwrite: 'auto' });
      var arrow = $('span', btn);
      if (arrow) gsap.to(arrow, { x: 0, y: 0, duration: 0.9, ease: 'elastic.out(1, 0.4)', overwrite: 'auto' });
    });
  }

  // Weglot swaps text nodes in place; split lines would no longer match the translated copy.
  function watchTranslations() {
    var weglot = window.Weglot;
    if (!weglot || typeof weglot.on !== 'function') return;
    weglot.on('languageChanged', function () {
      splits.forEach(function (s) { s.revert(); });
      splits = [];
      ScrollTrigger.refresh();
    });
  }

  var spotlight = buildSpotlight();
  spaceStack();

  heroScene();
  headlineReveals();
  solutionsScene();
  spotlightScene(spotlight);
  liquidCatalog();
  projectScene();
  spacesScene();
  processScene();
  closingScenes();
  colourShift();
  pointerFx();
  watchTranslations();

  window.addEventListener('wv-language-before-change', function () {
    splits.forEach(function (s) { if (s && typeof s.revert === 'function') s.revert(); });
    splits = [];
  });
  window.addEventListener('wv-language-change', function () {
    var motionRoot = document.getElementById('wv-home');
    if (window.WV_I18N && motionRoot) window.WV_I18N.applyNative(motionRoot);
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && typeof headlineReveals === 'function') headlineReveals();
    ScrollTrigger.refresh();
  });

  window.addEventListener('load', function () { ScrollTrigger.refresh(); });
  window.WV8Motion = { lenis: lenis, refresh: function () { ScrollTrigger.refresh(); } };
})();
